const lang = {
  state: {
    langType: sessionStorage.getItem("langType") || "zh"
  },

  mutations: {
    SET_LANGTYPE: (state, langType) => {
      state.langType = langType;
      sessionStorage.langType = langType;
    }
  },

  actions: {}
};

export default lang;



// WEBPACK FOOTER //
// ./src/store/modules/lang.js